/* Capitol style — khung trượt ngang dùng chung (danh mục, sản phẩm, đánh giá).
   Cuộn gốc của trình duyệt (vuốt mượt trên điện thoại); script chỉ lo mũi tên, chấm, kéo bằng chuột và tải ảnh.
   Mỗi khung: phần tử cha có [data-gv-strip], bên trong có .gv-strip__track và snippet gv-strip-nav. */
(function(){
  if(window.__gvStrip)return; window.__gvStrip=1;
  var reduce=matchMedia('(prefers-reduced-motion: reduce)');
  /* Horizon (máy tính) cuộn trong .page-wrapper thay vì cả cửa sổ -> dùng đúng khung cuộn để tải ảnh trước khi tới */
  function scroller(){var pw=document.querySelector('.page-wrapper');return (pw&&getComputedStyle(document.body).overflowY==='hidden')?pw:null}
  function init(sec){
    if(sec.dataset.stripReady)return; sec.dataset.stripReady='1';
    var track=sec.querySelector('.gv-strip__track'), nav=sec.querySelector('.gv-strip__nav'); if(!track||!nav)return;
    var dotsBox=nav.querySelector('.gv-strip__dots'), prev=nav.querySelector('.gv-strip__arrow--prev'), next=nav.querySelector('.gv-strip__arrow--next');
    var stops=[0], page=0, tilePx=1, perFull=1;
    function gapPx(){return parseFloat(getComputedStyle(track).columnGap)||0}
    function measure(){
      var items=track.children; if(!items.length)return;
      var max=track.scrollWidth-track.clientWidth;
      if(max<=2){stops=[0];nav.hidden=true;return}
      nav.hidden=false;
      var w=items[0].getBoundingClientRect().width, gap=gapPx();
      var per=Math.max(1,Math.floor((track.clientWidth+gap+1)/(w+gap)));   /* số ô hiện trọn vẹn */
      var step=per*(w+gap); tilePx=w+gap; perFull=per;
      stops=[]; for(var x=0;x<max-2;x+=step)stops.push(Math.round(x)); stops.push(max);
      dotsBox.innerHTML='';
      /* Quá nhiều trang so với chỗ trống -> hiện "3 / 12" thay cho hàng chấm */
      var dw=parseFloat(nav.dataset.dotW)||19, rs=nav.dataset.reserve!=null?parseFloat(nav.dataset.reserve):101;
      var room=Math.floor((nav.clientWidth-rs)/dw);
      if(stops.length>room){var c=document.createElement('span');c.className='gv-strip__count';dotsBox.appendChild(c)}
      else stops.forEach(function(_,k){var b=document.createElement('button');b.type='button';b.className='gv-strip__dot';b.setAttribute('aria-label','Page '+(k+1)+' of '+stops.length);b.setAttribute('aria-controls',track.id);b.addEventListener('click',function(){go(k)});dotsBox.appendChild(b)});
      sync();
    }
    function sync(){
      var x=track.scrollLeft, last=stops.length-1, max=track.scrollWidth-track.clientWidth;
      var firstIdx=Math.round(x/tilePx);
      page = x>=max-2 ? last : Math.min(last, Math.ceil(firstIdx/perFull));
      var cnt=dotsBox.querySelector('.gv-strip__count');
      if(cnt)cnt.textContent=(page+1)+' / '+stops.length;
      else Array.prototype.forEach.call(dotsBox.children,function(d,k){d.setAttribute('aria-current',k===page?'true':'false')});
      prev.setAttribute('aria-disabled',page===0?'true':'false');
      next.setAttribute('aria-disabled',page===stops.length-1?'true':'false');
    }
    function go(k){k=Math.max(0,Math.min(stops.length-1,k));track.scrollTo({left:stops[k],behavior:reduce.matches?'auto':'smooth'})}
    prev.addEventListener('click',function(){if(prev.getAttribute('aria-disabled')!=='true')go(page-1)});
    next.addEventListener('click',function(){if(next.getAttribute('aria-disabled')!=='true')go(page+1)});
    var raf=0; track.addEventListener('scroll',function(){if(raf)return;raf=requestAnimationFrame(function(){raf=0;sync()})},{passive:true});

    /* Kéo bằng chuột (máy tính). Kéo > 6px thì coi là kéo: không mở link. */
    var down=false, dragging=false, sx=0, sl=0, suppress=false;
    track.addEventListener('dragstart',function(e){e.preventDefault()});
    track.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button!==0)return;down=true;dragging=false;sx=e.clientX;sl=track.scrollLeft});
    addEventListener('pointermove',function(e){
      if(!down)return; var dx=e.clientX-sx;
      if(!dragging&&Math.abs(dx)>6){dragging=true;track.classList.add('is-dragging');track.style.scrollSnapType='none'}
      if(dragging){track.scrollLeft=sl-dx;e.preventDefault()}
    });
    addEventListener('pointerup',function(){
      if(!down)return; down=false; if(!dragging)return;
      dragging=false; suppress=true; setTimeout(function(){suppress=false},0);
      track.classList.remove('is-dragging');
      var max=track.scrollWidth-track.clientWidth, target=Math.min(max,Math.round(track.scrollLeft/tilePx)*tilePx);
      track.scrollTo({left:target,behavior:reduce.matches?'auto':'smooth'});
      setTimeout(function(){track.style.scrollSnapType=''},450);
    });
    track.addEventListener('click',function(e){if(suppress){e.preventDefault();e.stopPropagation();suppress=false}},true);

    /* Ảnh: chỉ tải SAU khi trang (và banner) xong + khi khung gần tới. Ô đang hiện + ô kế tiếp trước, còn lại lúc rảnh. */
    var imgs=Array.prototype.slice.call(track.querySelectorAll('img[data-src]'));
    function loadImg(im){if(!im.dataset.src)return;im.addEventListener('load',function(){im.classList.add('is-loaded')},{once:true});if(im.dataset.srcset)im.srcset=im.dataset.srcset;im.src=im.dataset.src;im.removeAttribute('data-src');im.removeAttribute('data-srcset');if(im.complete&&im.naturalWidth)im.classList.add('is-loaded')}
    function loadVisible(){var t=track.getBoundingClientRect();imgs.forEach(function(im){var r=im.getBoundingClientRect();if(r.left<t.right+r.width+gapPx()&&r.right>t.left-1)loadImg(im)})}
    function start(){
      if(!imgs.length)return;
      if(!('IntersectionObserver' in window)){imgs.forEach(loadImg);return}
      new IntersectionObserver(function(es,io){if(es.some(function(e){return e.isIntersecting})){io.disconnect();loadVisible();
        var rest=function(){imgs.forEach(loadImg)};('requestIdleCallback' in window)?requestIdleCallback(rest,{timeout:3000}):setTimeout(rest,1500)}},{root:scroller(),rootMargin:'300px 0px'}).observe(sec);
      track.addEventListener('scroll',loadVisible,{passive:true});
    }
    (document.readyState==='complete')?start():addEventListener('load',start,{once:true});
    /* Bàn phím: ô đang được chọn luôn hiện trọn */
    track.addEventListener('focusin',function(e){var li=e.target.closest('.gv-strip__track > *');if(!li)return;var r=li.getBoundingClientRect(),t=track.getBoundingClientRect();if(r.left<t.left-1||r.right>t.right+1)li.scrollIntoView({block:'nearest',inline:'nearest',behavior:reduce.matches?'auto':'smooth'})});
    if('ResizeObserver' in window)new ResizeObserver(measure).observe(track); else addEventListener('resize',measure);
    measure();
  }
  function all(root){Array.prototype.forEach.call((root||document).querySelectorAll('[data-gv-strip]'),init)}
  all();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){all()});
  document.addEventListener('shopify:section:load',function(e){all(e.target)});
})();
